// eslint-disable-next-line import/prefer-default-export
export const CAMPAIGN_STATUS = {
  DISABLE: 'DISABLE',
  ENABLE: 'ENABLE',
}

export const AD_STATUS = {
  DISABLE: 'AD_STATUS_CAMPAIGN_DISABLE',
  ENABLE: 'ENABLE',
}

export const BUDGET_MODE = {
  BUDGET_MODE_DYNAMIC_DAILY_BUDGET: 'BUDGET_MODE_DYNAMIC_DAILY_BUDGET',
  BUDGET_MODE_INFINITE: 'BUDGET_MODE_INFINITE',
  BUDGET_MODE_DAY: 'BUDGET_MODE_DAY',
  BUDGET_MODE_TOTAL: 'BUDGET_MODE_TOTAL',
}
